export enum WeedsClassKeys {
  GW = 'Digit1',
  BRLOW = 'Digit2',
  CW = 'Digit3',
  BRHIW = 'Digit4'
}
